import { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { initTracking, trackViewContent } from "@/lib/tracking";
import { Header } from "@/components/overclock/Header";
import { Hero } from "@/components/overclock/Hero";
import { StrokeMarquee } from "@/components/overclock/StrokeMarquee";
import { Manifesto } from "@/components/overclock/Manifesto";
import { Ingredients } from "@/components/overclock/Ingredients";
import { ProductSection } from "@/components/overclock/ProductSection";
import { SocialProof } from "@/components/overclock/SocialProof";
import { Faq } from "@/components/overclock/Faq";
import { Footer } from "@/components/overclock/Footer";

const MobileBar = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 border-t border-zinc-800 bg-zinc-950/90 backdrop-blur-xl px-4 py-3 transition-transform duration-300 lg:hidden ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <button
        data-testid="mobile-buy-btn"
        onClick={() =>
          document.getElementById("buy")?.scrollIntoView({ behavior: "smooth" })
        }
        className="flex w-full items-center justify-center gap-2 bg-blaze py-3.5 font-mono text-sm font-bold uppercase tracking-[0.12em] text-black"
      >
        <Zap className="h-4 w-4" fill="currentColor" /> Enter God Mode — from $41.95
      </button>
    </div>
  );
};

export default function ProductPage() {
  useEffect(() => {
    initTracking();
    trackViewContent();
  }, []);
  return (
    <div className="relative bg-[#09090B]">
      <Header />
      <main>
        <Hero />
        <StrokeMarquee />
        <ProductSection />
        <Manifesto />
        <Ingredients />
        <SocialProof />
        <Faq />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
